/**
 * Representa os tipos de alvo para aplicação/remoção em lote de seleções configuráveis.
 */
export enum ESelectionApplyTargetType {
  AllProducts,
  SelectedProducts,
  AllMeals,
  SelectedMeals,
  AllDrinks,
  SelectedDrinks,
  AllCombos,
  SelectedCombos,
}
